import { HttpClient, HttpEvent, HttpHeaders, HttpResponse } from "@angular/common/http";
import { map, Observable, tap } from "rxjs";
import { AuthService } from "./auth.service";
import { AbstractHttpService } from "./http-abstract.service";
import { Injectable } from "@angular/core";
import { AgentDto, AgentFieldValidationDto, AgentProvisionFormDataDto, DocumentDto, MaskingDto, MsisdnDto, PartnerDto, ResultListDto, SearchResultDocumentDto, SearchResultMsisdnDto, SentOtpDto, SubscriberFullDto } from "./dto";

@Injectable({
	providedIn: 'root'
})
export class HttpClearSystemDataService extends AbstractHttpService {
	constructor(httpClient: HttpClient, authService: AuthService) {
		super(httpClient, '/api/gui/clear_system_data', authService);
	}

	public requestOtp(): Observable<SentOtpDto> {
		return super.doGet(true, `/request_otp`);
	}
	public execute(input: string): Observable<SentOtpDto>{
		return super.doPost(true, `/execute`, input);
	}
}
